//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    reserve: {
      type: Array,
      default: function () {
        return []
      }
    },
    formatInt: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    calcSummaAmounts: function () {
      return this.countReserveAmounts()
    }
  },
  methods: {
    countReserveAmounts: function () {
      let summaAmounts = 0.0
      if (this.reserve !== null) {
        summaAmounts = this.reserve.reduce(function (accumulator, currentValue) {
          return accumulator + currentValue.amount
        }, 0.0)
      }

      return summaAmounts
    },
    goToRequest (id) {
      this.$router.push('/stockInventoryTask/' + id)
    }
  }
}
